export class InteractiveDataAnalysisSignalChartProperties {
  signalId: string = '';
  signalName: string = '';
  axisYLabel: string = '';
  signalType: string = '';
  displayedText: string = '';
  scale: number = 0;
  unit: string = '';
  customRange: boolean = false;
  customYAxisInterval: boolean = false;
  minY: number = 0;
  maxY: number = 0;
  axis: Axis = Axis.LEFT;
  colors: Colors = new Colors();
}

class Colors {
  main: string = '';
}

export enum Axis {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}